import constants from 'core/types'
import { takeEvery, select, put, call } from 'redux-saga/effects'
import { parseUnits, Contract, formatUnits } from 'ethers'
import { getContractAddressFromChainId } from 'core/libs/lib-rpc-helpers'
import ZorkitronABI from "../../../../artifacts/contracts/Zorkitron.sol/Zorkitron.json"

export function* addLiquidity(action) {
  const { metaMaskAccount } = yield select(state => state.provider)
  const { token0, token1, token0Amount, token1Amount } = yield select(state => state.currency)
  const { toAddress, amount } = action

  if(window.ethereum) {
    /* If user is logged into MetaMask, execute tx (transaction).
       Otherwise, prompt user to install MetaMask
    */
    if(metaMaskAccount && metaMaskAccount.length) {
      try {
        const { signer, chainId } =  yield select(state => state.provider)
        const contractAddress = getContractAddressFromChainId(chainId)      
        
        // Connected to a Signer; can make state changing transactions,
        // which will cost the account ether.        
        const contract = new Contract(
          contractAddress,
          ZorkitronABI.abi,
          signer
        )

        const tx= yield call(
          [contract, 'addLiquidity'],
          token0.address.toString(),
          token1.address.toString(),
          parseUnits(token0Amount.toString(), 18),
          parseUnits(token1Amount.toString(), 18)
        )
        const txReceipt = yield call([tx,'wait'])
        const transactionStatus = `${amount} tokens credited to ${toAddress}`

        yield put({
          type: constants.OPEN_SNACK_BAR,
          payload: { 
            message: `Transaction status: ${transactionStatus}`,
            snackBarOpen: true
          }
        })

        console.log('---------------- deployed contract is ------------', contract)
        console.log('---------------- contractAddress -----------------', contractAddress)
        console.log('---------------- ZorkitronABI.abi -----------------', ZorkitronABI.abi)
        console.log('---------------- signer -----------------', signer)
        console.log('---- Deposit Liquidity receipt is: ----', txReceipt)

      } catch(e) {
        const errorToStr = JSON.stringify(e)
        const errorObj = JSON.parse(errorToStr)
        const { shortMessage } = errorObj
        const transactionStatus = `Transaction Failed: ${shortMessage}`
        
        console.log('----- errorObj -----', errorObj)

        yield put({
          type: constants.OPEN_SNACK_BAR,
          payload: { 
            message: `Transaction status: ${transactionStatus}`,
            snackBarOpen: true
          }
        })
      }
    } else {
      yield put({ 
        type: constants.OPEN_RIGHT_DRAWER
      })
    }
  } else {
    yield put({
      type: constants.OPEN_MODAL,
      payload: { modalKey: 'install-metamask-prompt' }
    })
  }
}

export function* watchTransactionActions() {
  yield takeEvery(constants.ADD_LIQUIDITY, addLiquidity)
}
